import * as React from 'react';
import { IconHelp } from '@tabler/icons-react';
import { Affix, Button, rem, ActionIcon } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { openContextModal } from '@mantine/modals';
import { useTranslation } from 'react-i18next';

interface GetHelpButtonProps {
    subtle?: boolean;
    none?: boolean;
}

export const GetHelpButton: React.FC<GetHelpButtonProps> = ({ subtle, none }) => {
    const { t } = useTranslation('common');
    const matches = useMediaQuery('(min-width: 768px)');
    const onClick = React.useCallback(() => {
        openContextModal({
            modal: 'help',
            title: 'Test modal from context',
            innerProps: {
                modalBody:
                    'This modal was defined in ModalsProvider, you can open it anywhere in you app with useModals hook'
            }
        });
    }, []);
    if (none) return null;
    return subtle ? (
        <ActionIcon variant="subtle" onClick={onClick}>
            <IconHelp size="1.125rem" />
        </ActionIcon>
    ) : (
        <Affix position={{ bottom: rem(20), right: rem(20) }}>
            <Button
                size="md"
                leftIcon={matches ? <IconHelp size="1.2rem" /> : null}
                color="teal"
                style={{
                    boxShadow: '2px 2px 10px #80808094'
                }}
                onClick={onClick}
            >
                {matches ? t('help') : <IconHelp size="1.2rem" />}
            </Button>
        </Affix>
    );
};
